import { csx } from '@vtex/admin-ui'
import type { HTMLAttributes } from 'react'
import React from 'react'

export type ProductImageRootProps = HTMLAttributes<HTMLDivElement>

export const ProductImageRoot = (props: ProductImageRootProps) => (
  <div
    className={csx({
      '@desktop': {
        display: 'grid',
        gridTemplateColumns: 'minmax(50px, 1fr) 10fr',
        gap: '$space-5',
        position: 'relative',
      },
    })}
    {...props}
  />
)
